// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Documents_mainContainer__1QmnR"};